<template>
    <div>
        <ContentHeader />
		<div v-if="loading" class="loading">
			<div class="loader"></div>
			<img src="@/assets/img/logo.jpg" alt="logo" width="496" height="99" class="loaderLogo">
		</div>
          <div class="productBanner" data-aos="fade-out">
            <span>text</span>
          </div>
          <div class="block">
            <div class="ctInner">
              <h1 class="leadTitle">Our Products</h1>
              <p>Elemax-Tech Engineering provides a full range of high-quality elevators and escalators supplied by OTSTEC. Safe, reliable, and designed for residential, commercial, and industrial applications.</p>
            </div>
          </div>
          <!-- Passenger Elevator -->
          <section class="product block bgGray">
            <div class="ctInner">
              <h2>Passenger Elevator</h2>
              <p>Our passenger elevators combine modern design with smooth performance and quiet operation. With advanced control systems and durable components, they ensure maximum efficiency and comfort for every ride.</p>
              <ul>
                <li>Stable and safe operation with VVVF drive control system</li>
                <li>Energy-saving LED lighting and intelligent standby mode</li>
                <li>Optional mirror finish, handrails, and display customization</li>
                <li>Suitable for apartments, hotels, hospitals, and offices</li>
              </ul>
              <div class="slider-wrapper type2">
                <VueSlickCarousel :arrows="true" :dots="true" :autoplay="true" :infinite="true" :slidesToShow="4" :slidesToScroll="1" :responsive="[{ breakpoint: 768, settings: { centerMode: true, centerPadding: '20%', slidesToShow: 1 } }]">
                  <div v-for="(image, index) in images" :key="index" class="slide">
                    <img :src="image" alt="" />
                  </div>
                </VueSlickCarousel>
              </div>
            </div>
          </section>

          <!-- Panoramic Elevator -->
          <section class="product block">
            <div class="ctInner">
              <h2>Panoramic Elevator</h2>
              <p>Panoramic elevators add elegance and transparency to modern buildings. The 360° glass design provides a scenic view and creates a luxurious architectural statement.</p>
              <ul>
                <li>Tempered glass cabin and panoramic wall design</li>
                <li>Smooth acceleration and noise-free movement</li>
                <li>Ideal for malls, hotels, and commercial complexes</li>
              </ul>
              <div class="slider-wrapper type2">
                <VueSlickCarousel :arrows="true" :dots="true" :autoplay="true" :infinite="true" :slidesToShow="4" :slidesToScroll="1" :responsive="[{ breakpoint: 768, settings: { centerMode: true, centerPadding: '20%', slidesToShow: 1 } }]">
                  <div v-for="(image2, index) in images2" :key="index" class="slide">
                    <img :src="image2" alt="" />
                  </div>
                </VueSlickCarousel>
              </div>
            </div>
          </section>

          <!-- Home Elevator -->
          <section class="product block bgGray">
            <div class="ctInner">
              <h2>Home Elevator</h2>
              <p>Our home elevators are compact, quiet, and customizable to suit your home’s interior. They provide convenience for all family members, especially seniors and people with mobility needs.</p>
              <ul>
                <li>Space-saving design and energy-efficient system</li>
                <li>Various door opening types and cabin materials available</li>
                <li>Simple installation with low maintenance requirements</li>
              </ul>
              <div class="slider-wrapper type2">
                <VueSlickCarousel :arrows="true" :dots="true" :autoplay="true" :infinite="true" :slidesToShow="4" :slidesToScroll="1" :responsive="[{ breakpoint: 768, settings: { centerMode: true, centerPadding: '20%', slidesToShow: 1 } }]">
                  <div v-for="(image, index) in images3" :key="index" class="slide">
                    <img :src="image" alt="" />
                  </div>
                </VueSlickCarousel>
              </div>
            </div>
          </section>

          <!-- Hospital Elevator -->
          <section class="product block">
            <div class="ctInner">
              <h2>Hospital Elevator</h2>
              <p>Specifically designed for hospitals and clinics, these elevators ensure smooth, stable, and hygienic operation for stretchers, wheelchairs, and medical equipment.</p>
              <ul>
                <li>Wide doors and spacious cabins for stretchers</li>
                <li>Anti-bacterial interior finishes and soft start system</li>
                <li>Reliable emergency power backup system</li>
              </ul>
              <div class="slider-wrapper type2">
                <VueSlickCarousel :arrows="true" :dots="true" :autoplay="true" :infinite="true" :slidesToShow="4" :slidesToScroll="1" :responsive="[{ breakpoint: 768, settings: { centerMode: true, centerPadding: '20%', slidesToShow: 1 } }]">
                  <div v-for="(image, index) in images4" :key="index" class="slide">
                    <img :src="image" alt="" />
                  </div>
                </VueSlickCarousel>
              </div>
            </div>
          </section>

          <!-- Freight Elevator -->
          <section class="product block bgGray">
            <div class="ctInner">
              <h2>Freight Elevator</h2>
              <p>Our freight elevators are engineered for strength and durability. They can handle heavy cargo loads safely and efficiently in factories, warehouses, and logistics centers.</p>
              <ul>
                <li>Strong traction system with high load capacity</li>
                <li>Shock-resistant platform and durable cabin walls</li>
                <li>Stable operation under continuous heavy use</li>
              </ul>
              <div class="slider-wrapper type2">
                <VueSlickCarousel :arrows="true" :dots="true" :autoplay="true" :infinite="true" :slidesToShow="4" :slidesToScroll="1" :responsive="[{ breakpoint: 768, settings: { centerMode: true, centerPadding: '20%', slidesToShow: 1 } }]">
                  <div v-for="(image, index) in images5" :key="index" class="slide">
                    <img :src="image" alt="" />
                  </div>
                </VueSlickCarousel>
              </div>
            </div>
          </section>

          <!-- Escalator -->
          <section class="product block">
            <div class="ctInner">
              <h2>Escalator</h2>
              <p>OTSTEC escalators are designed for safety, stability, and style. They ensure a smooth passenger flow in busy areas with minimal maintenance downtime.</p>
              <ul>
                <li>Advanced safety sensors and automatic lubrication system</li>
                <li>Stainless steel balustrades and step chains for durability</li>
                <li>Suitable for shopping centers, airports, and transit stations</li>
              </ul>
              <div class="slider-wrapper type2">
                <VueSlickCarousel :arrows="true" :dots="true" :autoplay="true" :infinite="true" :slidesToShow="4" :slidesToScroll="1" :responsive="[{ breakpoint: 768, settings: { centerMode: true, centerPadding: '20%', slidesToShow: 1 } }]">
                  <div v-for="(image, index) in images6" :key="index" class="slide">
                    <img :src="image" alt="" />
                  </div>
                </VueSlickCarousel>
              </div>
            </div>
          </section>

          <!-- Moving Walk -->
          <section class="product block bgGray">
            <div class="ctInner">
              <h2>Moving Walk</h2>
              <p>Our moving walks (horizontal escalators) provide a comfortable and safe solution for passengers with luggage or carts. They are widely used in airports, supermarkets, and exhibition halls.</p>
              <ul>
                <li>Low-noise operation with automatic start/stop system</li>
                <li>Optional indoor or outdoor design</li>
                <li>Long lifespan with high energy efficiency</li>
              </ul>
              <div class="slider-wrapper type2">
                <VueSlickCarousel :arrows="true" :dots="true" :autoplay="true" :infinite="true" :slidesToShow="4" :slidesToScroll="1" :responsive="[{ breakpoint: 768, settings: { centerMode: true, centerPadding: '20%', slidesToShow: 1 } }]">
                  <div v-for="(image, index) in images7" :key="index" class="slide">
                    <img :src="image" alt="" />
                  </div>
                </VueSlickCarousel>
              </div>
            </div>
          </section>

          <!-- Car Elevator -->
          <section class="product block">
            <div class="ctInner">
              <h2>Car Elevator</h2>
              <p>Car elevators are the perfect solution for transporting vehicles between floors in parking buildings or car showrooms. They combine robust mechanical design with precise control systems.</p>
              <ul>
                <li>Heavy-duty platform with advanced hydraulic or traction system</li>
                <li>Anti-skid flooring and safety interlock system</li>
                <li>Smooth and stable lifting for all vehicle types</li>
              </ul>
              <div class="slider-wrapper type2">
                <VueSlickCarousel :arrows="true" :dots="true" :autoplay="true" :infinite="true" :slidesToShow="4" :slidesToScroll="1" :responsive="[{ breakpoint: 768, settings: { centerMode: true, centerPadding: '20%', slidesToShow: 1 } }]">
                  <div v-for="(image, index) in images5" :key="index" class="slide">
                    <img :src="image" alt="" />
                  </div>
                </VueSlickCarousel>
              </div>
            </div>
          </section>

          <!-- Dumbwaiter -->
          <section class="product block bgGray">
            <div class="ctInner">
              <h2>Dumbwaiter</h2>
              <p>A convenient solution for transporting small goods, meals, or documents between floors. Perfect for restaurants, hotels, and offices.</p>
              <ul>
                <li>Compact structure and easy installation</li>
                <li>Low noise and low energy consumption</li>
                <li>Stainless steel car for hygiene and durability</li>
              </ul>
            </div>
          </section>

          <!-- Customized Design -->
          <section class="product block">
            <div class="ctInner">
              <h2>Customized Design</h2>
              <p>We provide fully customized elevator and escalator solutions to meet your building’s architectural style and technical requirements.</p>
              <ul>
                <li>Custom cabin materials, lighting, and display panels</li>
                <li>Tailored capacity and speed settings</li>
                <li>Branding and color customization</li>
              </ul>
            </div>
          </section>

          <!-- Why choose us -->
          <section class="product block bgGray">
            <div class="ctInner">
              <h2>Why Choose Elemax-Tech Engineering?</h2>
              <ul>
                <li>Certified OTSTEC supplier</li>
                <li>Expert installation and after-sales maintenance</li>
                <li>Safety, efficiency, and long service life guaranteed</li>
              </ul>
              <router-link class="cta" to="/contact"><strong>Request a Quote</strong></router-link>
            </div>
          </section>
        <ContentFooter />
    </div>
</template>

<script>
  import ContentHeader from '@/components/ContentHeader.vue'
  import ContentFooter from '@/components/ContentFooter.vue'
  import VueSlickCarousel from 'vue-slick-carousel'
  export default {
    name: 'OurProductPage',
    components: {
      ContentHeader,
      ContentFooter,
      VueSlickCarousel
    },
    data() {
      return {
        images: [
          require('@/assets/img/passengerlift1.webp'),
          require('@/assets/img/passengerlift2.webp'),
          require('@/assets/img/passengerlift3.webp'),
          require('@/assets/img/passengerlift4.webp'),
          require('@/assets/img/passengerlift5.webp'),
          require('@/assets/img/passengerlift6.webp'),
          require('@/assets/img/passengerlift7.webp')
        ],
        images2: [
          require('@/assets/img/panoramiclift1.webp'),
          require('@/assets/img/panoramiclift2.webp'),
          require('@/assets/img/panoramiclift3.webp'),
          require('@/assets/img/panoramiclift4.webp'),
          require('@/assets/img/panoramiclift5.webp'),
          require('@/assets/img/panoramiclift6.webp'),
          require('@/assets/img/panoramiclift7.webp'),
        ],
        images3: [
          require('@/assets/img/homelift1.webp'),
          require('@/assets/img/homelift2.webp'),
          require('@/assets/img/homelift3.webp'),
          require('@/assets/img/homelift4.webp'),
          require('@/assets/img/homelift5.webp'),
          require('@/assets/img/homelift6.webp'),
          require('@/assets/img/homelift7.webp'),
        ],
        images4: [
          require('@/assets/img/hospitallift1.webp'),
          require('@/assets/img/hospitallift2.webp'),
          require('@/assets/img/hospitallift3.webp'),
          require('@/assets/img/hospitallift4.webp'),
          require('@/assets/img/hospitallift5.webp')
        ],
        images5: [
          require('@/assets/img/freightlift1.webp'),
          require('@/assets/img/freightlift2.webp'),
          require('@/assets/img/freightlift3.webp'),
          require('@/assets/img/freightlift4.webp'),
          require('@/assets/img/freightlift5.webp'),
          require('@/assets/img/freightlift6.webp'),
          require('@/assets/img/freightlift7.webp')
        ],
        images6: [
          require('@/assets/img/escalator1.webp'),
          require('@/assets/img/escalator2.webp'),
          require('@/assets/img/escalator3.webp'),
          require('@/assets/img/escalator4.webp'),
          require('@/assets/img/escalator5.webp'),
          require('@/assets/img/escalator6.webp')
        ],
        images7: [
          require('@/assets/img/movingwalk1.webp'),
          require('@/assets/img/movingwalk2.webp'),
          require('@/assets/img/movingwalk3.webp'),
          require('@/assets/img/movingwalk4.webp'),
          require('@/assets/img/movingwalk5.webp')
        ],
		
		loading: true
      };
    },
	mounted() {
		this.loading = false;
	}
  }
</script>